module.exports = __webpack_public_path__ + "static/img/news_banner.9a9940b9.jpg";